module.exports = __webpack_public_path__ + "static/media/red_nebula_RT.8e96b1e0.png";